import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProjectSample from "../../project_samples/ProjectSamples";
import ProjectSampleMobile from "../../project_samples/ProjectSamplesMobile";

const footerLinks = [
  { label: "Home", href: "/" },
  { label: "Wearable Art & Thangz", href: "/merch" },
  { label: "Original Paintings", href: "/original-paintings-1" },
  { label: "Limited Edition Prints", href: "/Prints" },
];

const CollectionFooter = () => (
  <footer className="collection-footer">
    <div className="collection-footer-brand">
      <h2>You Are Art</h2>
      <p>Wearable art, original paintings, and limited edition prints.</p>
    </div>
    <nav className="collection-footer-nav" aria-label="Footer navigation">
      {footerLinks.map((link) => (
        <Link key={link.href} to={link.href}>
          {link.label}
        </Link>
      ))}
    </nav>
    <p className="collection-footer-copyright">
      &copy; {new Date().getFullYear()} Reena Tolentino. All rights reserved.
    </p>
  </footer>
);

const Collection = ({
  items,
  title,
  variant = "default",
  eyebrow,
  description,
  backgroundImage,
  pageClassName = "",
  showFooter = false,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (variant === "boutique") {
    const resolvedEyebrow =
      eyebrow ?? (backgroundImage ? "Original Paintings" : undefined);

    const pageClassNames = [
      "Content",
      "collection-page",
      backgroundImage && "collection-page--with-background",
      pageClassName,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <main
        className={pageClassNames}
        style={
          backgroundImage
            ? { "--collection-bg-image": `url(${backgroundImage})` }
            : undefined
        }
      >
        <section className="collection-intro" aria-labelledby="collection-title">
          {resolvedEyebrow && (
            <p className="collection-eyebrow">{resolvedEyebrow}</p>
          )}
          <h1 id="collection-title" className="collection-title-main">
            {title}
          </h1>
          {description && (
            <p className="collection-description">{description}</p>
          )}
        </section>

        <section className="collection-grid-section" aria-label={`${title} products`}>
          {isMobile ? (
            <ProjectSampleMobile items={items} />
          ) : (
            <ProjectSample items={items} />
          )}
        </section>

        {showFooter && <CollectionFooter />}
      </main>
    );
  }

  return (
    <>
      <div className="Content">
        {isMobile ? (
          <>
            <section className="section-project-description-mobile">
              <h2 className="project-title2">{title}</h2>
            </section>
            <div className="upper-section">
              <ProjectSampleMobile items={items} />
            </div>
          </>
        ) : (
          <>
            <section className="section-project-description2">
              <h2 className="project-title2">{title}</h2>
            </section>
            <div className="upper-section">
              <ProjectSample items={items} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Collection;
